<script setup>
// import { BFormInput} from 'bootstrap-vue-next';
import HeaderContent from '@/components/HeaderContent.vue';
import DataTable from '@/components/DataTable.vue';
// import FilterSearch from '@/components/FilterSearch.vue';
import ButtonCta from '@/components/ButtonCta.vue';
import ActionContent from '@/components/ActionContent.vue';
import InventoryModalForm from '../InventoryModalForm.vue';
import { ref } from 'vue'

const inventoryModal = ref(false)
</script>

<template>
    <HeaderContent title="Warehouse Inventory"/>
    <ActionContent :filterDate="false" :cta="false"></ActionContent>

    <!-- Statistic -->
    <div class="mt-4 table-responsive bg-white rounded-3 mb-0">
        <div class="px-4 pt-4 d-lg-flex align-items-center justify-content-start">
            <ButtonCta class="" v-if=" inventoryName !== 'spoil' && inventoryName !== 'overall' " text="Add New" show="true" @action="inventoryModal = !inventoryModal"></ButtonCta>
        </div>

        <DataTable :data="data" :header="fields" :currentPage="currentPage" :custom-actions="customActions"></DataTable>
    </div>

      <!-- Modalform -->
      <InventoryModalForm v-model="inventoryModal" @update:modal="modal = $event"></InventoryModalForm>
</template>

<script>
const fields =[
    { key: 'id', label: 'Id',class: 'text-left'},
    { key: 'name', label: 'Name',class: 'text-left'},
    { key: 'category', label: 'Category',class: 'text-center'},
    { key: 'qty', label: 'Qty',class: 'text-center'},
    { key: 'last_update', label: 'Last Update',thClass:'text-center',tdClass:'text-center'},
    { key: 'updated_by', label: 'Updated By',class: 'text-center'},
    { key: 'action', label: 'Action',thClass:'text-center',tdClass:'text-center'},    
]

const data = [
    {
        id: 'I001',
        name: 'Double Sheet',
        category: 'Item',
        qty: 62,
        last_update : '01/02/2025',
        updated_by : 'Mr Admin',
    },
    {
        id: 'I001',
        name: 'Single Sheet',
        category: 'Item',
        qty: 43,
        last_update : '01/02/2025',
        updated_by : 'Mr Admin',
    },
    {
        id: 'I003',
        name: 'Bath Towel',
        category: 'Item',
        qty: 41,
        last_update : '01/02/2025',
        updated_by : 'Mr admin',
    },
    {
        id: 'P001',
        name: 'Tooth Paste',
        category: 'Product',
        qty: 186,
        last_update : '01/02/2025',
        updated_by : 'Mr admin',
    },
    {
        id: 'P002',
        name: 'Soft Drink',
        category: 'Product',
        qty: 261,
        last_update : '01/02/2025',
        updated_by : 'Mr admin',
    },
    {
        id: 'P003',
        name: 'Snacks',
        category: 'Product',
        qty: 242,
        last_update : '01/02/2025',
        updated_by : 'Mr admin',
    },
]

const customActions = [
    {
        label: 'History',
        variant: 'secondary',
        icon: 'fas fa-history',
        action: (item) => {
        console.log('Payment action clicked for:', item);
        // Implement your Payment logic here
        }
    },
    {
        label: 'Edit',
        variant: 'success',
        icon: 'fas fa-edit',
        action: (item) => {
        console.log('Info action clicked for:', item);
        // Implement your Info logic here
        }
    },
    {
        label: 'Delete',
        variant: 'danger',
        icon: 'fas fa-trash',
        action: (item) => {
        console.log('Info action clicked for:', item);
        // Implement your Info logic here
        }
    },
]

</script>

<style>
@media screen and (max-width: 576px) {
    
    
}
</style>